import React from 'react';
import { Skeleton } from 'components/ui/skeleton';

const TABS = ['w-36', 'w-24', 'w-20', 'w-28', 'w-24', 'w-40', 'w-16'];
const BONE = 'bg-gray-200';

export const AdminParticipantsTableSkeleton = () => (
    <table
        className="min-w-full divide-y divide-gray-200"
        data-testid="admin-participants-skeleton"
        aria-busy="true"
        aria-label="Loading"
    >
        <thead className="bg-gray-50">
            <tr>
                <th className="px-6 py-3 text-left"><Skeleton className={`h-3 w-24 ${BONE}`} /></th>
                <th className="px-6 py-3 text-left"><Skeleton className={`h-3 w-16 ${BONE}`} /></th>
                <th className="px-6 py-3 text-left"><Skeleton className={`h-3 w-16 ${BONE}`} /></th>
            </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
            {[0, 1, 2, 3, 4, 5].map((row) => (
                <tr key={row} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                            <Skeleton className={`h-10 w-10 shrink-0 rounded-full ${BONE}`} />
                            <div className="ml-4 space-y-2">
                                <Skeleton className={`h-4 w-36 ${BONE}`} />
                                <Skeleton className={`h-4 w-44 ${BONE}`} />
                            </div>
                        </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                        <Skeleton className={`h-6 w-24 rounded-full ${BONE}`} />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex space-x-2">
                            <Skeleton className={`h-7 w-24 ${BONE}`} />
                            <Skeleton className={`h-7 w-20 ${BONE}`} />
                        </div>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
);

const AdminSkeleton = () => (
    <div
        className="min-h-screen min-w-0 bg-gray-50"
        aria-busy="true"
        aria-label="Loading"
        data-testid="admin-skeleton"
    >
        <div className="mx-auto min-w-0 max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
            <div className="mb-8 flex gap-8 border-b border-gray-200 pb-3">
                {TABS.map((width, index) => (
                    <Skeleton key={index} className={`h-4 ${width} ${BONE}`} />
                ))}
            </div>
            <div className="bg-white shadow rounded-lg">
                <div className="flex flex-col gap-4 border-b border-gray-200 p-6 sm:flex-row">
                    <Skeleton className={`h-10 flex-1 ${BONE}`} />
                    <Skeleton className={`h-10 w-full sm:w-36 ${BONE}`} />
                    <Skeleton className={`h-10 w-full sm:w-28 ${BONE}`} />
                </div>
                <div className="overflow-x-auto">
                    <AdminParticipantsTableSkeleton />
                </div>
            </div>
        </div>
    </div>
);

export default AdminSkeleton;
